import { useEffect } from 'react';

import useAuth from '@giro/shared-hooks/useAuth.hook';

import useCurrentUrl from '@giro-app/hooks/useCurrentUrl.hook';

import ROUTES from '@giro-app/constants/routes.constant';

export default function useProtectedByAuth() {
  const { signedIn } = useAuth();

  const authclientUrl = ROUTES.EXTERNAL.AUTH.LOGIN;

  const currentUrl = useCurrentUrl();

  useEffect(() => {
    if (!signedIn) {
      window.location.href = `${authclientUrl}?redirectUrl=${currentUrl}`;
    }
  }, [currentUrl, signedIn]);
}
